import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { OdsServices } from '../../services';
import { TakeawayServices } from '../../../takeaway/services';
import * as firebase from 'firebase';

/**
 * Generated class for the OdsListViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-config-horary',
    templateUrl: 'ods-config-horary.html',
})
export class OdsConfigHoraryPage {
    firestore: any;
    schedules: any = [];
    start: any = "";
    end: any = "";
    monday: boolean = false;
    tuesday: boolean = false;
    wednesday: boolean = false;
    thursday: boolean = false;
    friday: boolean = false;
    saturday: boolean = false;
    sunday: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices) {
        this.firestore = firebase.firestore();
    }

    addHorary() {
        //Comprovar que se hayan añadido las horas, y seleccionado minimo 1 dia
        if (this.start != "" && this.end != "" && (this.monday || this.tuesday || this.wednesday || this.thursday || this.friday || this.saturday || this.sunday)) {
            this.schedules.push({
                start: this.start,
                end: this.end,
                monday: this.monday,
                tuesday: this.tuesday,
                wednesday: this.wednesday,
                thursday: this.thursday,
                friday: this.friday,
                saturday: this.saturday,
                sunday: this.sunday
            });
            this.start = "";
            this.end = "";
            this.monday = false;
            this.tuesday = false;
            this.wednesday = false;
            this.thursday = false;
            this.friday = false;
            this.saturday = false;
            this.sunday = false;
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('reservas-error-horario'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    deleteHorary(index) {
        this.schedules.splice(index, 1);
    }

    next() {
        //Guardamos las variables
        this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
            interval_between_orders: this.globals.restaurant.interval_between_orders || 30,
            number_orders: this.globals.restaurant.number_orders || 10,
            web_schedule: this.schedules
        });
        //
        this.globals.restaurant.number_orders = this.globals.restaurant.number_orders || 10,
        this.globals.restaurant.interval_between_orders = this.globals.restaurant.interval_between_orders || 30;
        this.globals.restaurant.web_schedule = this.schedules;
        //
        if (!this.odsServices.takeaway_config.config_horary) {
            this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').update({
                config_horary: true
            });
            this.odsServices.takeaway_config.config_horary = true;
        }
        this.navCtrl.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-horary/ods-config-horary.ts